import { PrivilegeChecker } from 'omni-common-ui';
import is from 'is_js';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import Assignments from './component';
import SessionNav from 'containers/Group/SessionNav';
import ViewNav from 'components/ViewNav';
import * as Homework from 'data/Homework/accessors';
import { accessors as PersonalisedHomework } from 'data/OnlineHomework/Personalised';
import * as Session from 'data/SessionPlans/accessors';
import { actions as groupActions } from 'containers/Group';

export const Modes = {
  CREATE_PERSONALISED_HW: 'create-personalised-hw',
  EDIT_PERSONALISED_HW: 'edit-personalised-hw',
  DELETE_PERSONALISED_HW: 'delete-personalised-hw',
  EDIT_GROUP_HOMEWORK: 'edit-group-homework',
  PUBLISH: 'publish',
  CLEAR: 'clear',
};

const actionButtons = (getState) => ({
  Publish: {
    route: { mode: Modes.PUBLISH, personalisedHomeworkId: null },
    isPrimary: true,
    visibleWhen: ({ params: { groupId } }) =>
      ! groupActions.isAutoPublishHomework(getState(), groupId) &&
        PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.Publish),
    disableWhen:
      ({ params: { mode, sessionPlanId } }) =>
        Session.isFutureSession(getState(), sessionPlanId) ||
        (PersonalisedHomework.isExisty(getState(), sessionPlanId) &&
          PersonalisedHomework.isPublished(getState(), sessionPlanId)) ||
          (! PersonalisedHomework.isExisty(getState(), sessionPlanId) &&
          ! canSubmitGroupHomework(getState(), sessionPlanId)) ||
         (Homework.isExisty(getState(), sessionPlanId) &&
          Homework.isPublished(getState(), sessionPlanId)) ||
        mode === Modes.PUBLISH ||
        mode === Modes.EDIT_GROUP_HOMEWORK,
  },
  'Add Personalised Practice': {
    route: { mode: Modes.CREATE_PERSONALISED_HW, personalisedHomeworkId: null },
    isPrimary: false,
    visibleWhen: ({ params: { groupId } }) =>
      ! groupActions.isAutoPublishHomework(getState(), groupId) &&
        PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.ManageOwn),
    disableWhen: ({ params: { mode, sessionPlanId } }) =>
      Session.isFutureSession(getState(), sessionPlanId) ||
      PersonalisedHomework.isPublished(getState(), sessionPlanId) ||
      Homework.isPublished(getState(), sessionPlanId) ||
      mode === Modes.CREATE_PERSONALISED_HW ||
      mode === Modes.EDIT_PERSONALISED_HW ||
      mode === Modes.EDIT_GROUP_HOMEWORK,
  },
  CLEAR: {
    route: { mode: Modes.CLEAR, personalisedHomeworkId: null },
    isPrimary: false,
    visibleWhen: ({ params: { sessionPlanId } }) =>
      Homework.hasWronglyResult(getState(), sessionPlanId),
  },
});

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'session-nav': {
        component: SessionNav,
        order: 1,
      },
      'view-nav': {
        component: ViewNav,
        order: 2,
      },
    },
  },
  path: 'session/:sessionPlanId(/unit/:unitId)(/:mode)(/:personalisedHomeworkId)',
  component: Assignments,
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.View) &&
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.AssignHomework),
  actionButtons: {
    default: actionButtons(getState),
    [Modes.CREATE_PERSONALISED_HW]: actionButtons(getState),
    [Modes.EDIT_PERSONALISED_HW]: actionButtons(getState),
    [Modes.DELETE_PERSONALISED_HW]: actionButtons(getState),
    [Modes.PUBLISH]: actionButtons(getState),
    [Modes.EDIT_GROUP_HOMEWORK]: actionButtons(getState),
    [Modes.CLEAR]: actionButtons(getState),
  },
});

function canSubmitGroupHomework(state, sessionId) {
  const homework = Homework.getHomeworkBySessionId(state, sessionId);
  const homeworkTemplate = Homework.getHomeworkTemplateBySessionId(state, sessionId);
  if (! homework) return false;
  if (is.undefined(homeworkTemplate) || homeworkTemplate.size === 0) return false;
  if (Homework.isPublished(state, sessionId)) return false;

  return true;
}



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/Assignments/routes.js